import React, { useEffect, useMemo, useRef, useState } from "react";
import "../../../CSS/Dashboard.css";
import ClientCarePlan from "../../../components/FormsInvoice/ClientCarePlan/ClintCarePlan.js";
import AgencyStore from "../../../Store/AgencyStore.js";
import PageTitle from "../../PageTitle.js";
import Icon from "../../../components/Icons/Icon.js";
import LeadsChart from "./LeadsChart.js";
import PieChartAdminEmployee from "./PieChartAdminEmployee.js";
import PieChartCordinator from "./PieChartCordinator.js";
import EmployeeChartNurse from "./EmployeeChartNurse.js";
import EmployeeChartCareAid from "./EmployeeChartCareAid.js";
import PieChartClient from "./PieChartClient.js";
import Notification from "./Notification.js";
import GlobelStore from "../../../Store/GlobelStore.js";
import ClientWorkHoursWidget from "./ClientWorkHoursWidget.js";

const Dashboard = React.memo(() => {
  const customAlert = useRef();
  const nurseRole = useMemo(() => GlobelStore.checkUserRole("Nurse"), []);
  const caregiverRole = useMemo(
    () => GlobelStore.checkUserRole("CareGiver"),
    []
  );
  const adminEmployeeRole = useMemo(
    () => GlobelStore.checkUserRole("AdminEmployee"),
    []
  );
  const communityCoordinatorRole = useMemo(
    () => GlobelStore.checkUserRole("CommunityCoordinator"),
    []
  );

  const notifications = useMemo(
    () => GlobelStore.checkUserRole("Notifications"),
    []
  );
  const clientRole = useMemo(() => GlobelStore.checkUserRole("Client"), []);
  const LeadsRole = useMemo(() => GlobelStore.checkUserRole("Leads"), []);

  useEffect(() => {
    GlobelStore.getDashboardData();
    AgencyStore.setCustomAlert(customAlert.current);
  }, []);

  return (
    <div>
      <div className="pageHeaderContainer">
        <PageTitle
          icon={<Icon iconName="menu" />}
          headerTitle="Dashboard"
          subHeaderTitle=" Navigation/Dashboard"
        />
      </div>
      <div className="pageMainContainer">
        <div className="dashboardGridContainer">
          {clientRole && <ClientWorkHoursWidget />}
        </div>
        <div className="dashboardGridContainer">
          {clientRole && <PieChartClient />}
          {notifications && <Notification />}
        </div>
        <div className="dashboardGridContainer">
          <div className="dashboardChartContainer">
            {adminEmployeeRole && <PieChartAdminEmployee />}
            {communityCoordinatorRole && <PieChartCordinator />}
          </div>

          {LeadsRole && <LeadsChart />}
        </div>
        <div className="dashboardFullWidthContainer">
          {nurseRole && <EmployeeChartNurse />}
        </div>
        <div className="dashboardFullWidthContainer">
          {caregiverRole && <EmployeeChartCareAid />}
        </div>
      </div>
    </div>
  );
});

export default Dashboard;
